import React from 'react'
import ContactBanner from '../../Components/Layout/ContactUs/ContactBanner'
import ContactDetails from '../../Components/Layout/ContactUs/ContactDetails'
import ContactMap from '../../Components/Layout/ContactUs/ContactMap'
import ContactForm from '../../Components/Layout/ContactUs/ContactForm'
import MiddleBanner from '../../Components/Layout/Home/Middlebanner'

const Contact = () => {
  return (
    <div>
      <ContactBanner />
      <ContactDetails />
      <ContactMap />
      <ContactForm />
      <MiddleBanner />
    </div>
  )
}

export default Contact
